'use client'

import { useState, useEffect } from 'react'

const words = [
    'admissional',
    'demissional',
    'periódico',
    'mudança de função',
    'retorno ao trabalho'
]

export default function TypewriterEffect() {
    const [currentWordIndex, setCurrentWordIndex] = useState(0)
    const [currentText, setCurrentText] = useState('')
    const [isDeleting, setIsDeleting] = useState(false)
    const [typingSpeed, setTypingSpeed] = useState(150)

    useEffect(() => {
        const handleType = () => {
            const fullText = words[currentWordIndex]

            if (isDeleting) {
                setCurrentText(fullText.substring(0, currentText.length - 1))
                setTypingSpeed(50) // Faster backspace
            } else {
                setCurrentText(fullText.substring(0, currentText.length + 1))
                setTypingSpeed(150) // Normal typing speed
            }

            if (!isDeleting && currentText === fullText) {
                setTimeout(() => setIsDeleting(true), 1500) // Wait before deleting
            } else if (isDeleting && currentText === '') {
                setIsDeleting(false)
                setCurrentWordIndex((prev) => (prev + 1) % words.length)
            }
        }

        const timer = setTimeout(handleType, typingSpeed)
        return () => clearTimeout(timer)
    }, [currentText, isDeleting, currentWordIndex, typingSpeed])

    return (
        <span className="relative inline-block">
            {/* Invisible placeholder containing the longest word to reserve layout space */}
            <span className="opacity-0 pointer-events-none select-none text-green-600 border-r-2 border-transparent pr-1" aria-hidden="true">
                retorno ao trabalho
            </span>
            {/* Typed text positioned absolutely over the reserved space */}
            <span className="absolute left-0 top-0 text-green-600 border-r-2 border-green-600 pr-1 animate-blink-border whitespace-nowrap">
                {currentText}
            </span>
        </span>
    )
}

